import React, { useState } from "react"
import { Form, Input, Button, Alert, Card, Col, Row, Modal } from "antd"
import { API } from "../utils/API"
import moment from "moment"
import ICDD_download_header from "../images/ICDD_download_header.png"
import thank_you from "../images/thank_you.png"
import img_pdf_2 from "../images/img_pdf_2.png"
import img_pdf_4_axiom from "../images/img_pdf_4_axiom.png"
import img_pdf_4_minerals from "../images/img_pdf_4_minerals.png"
import img_pdf_5 from "../images/img_pdf-5.png"
import dotenv from "dotenv"
dotenv.config()

const baseURL = process.env.REACT_APP_DOWNLOAD_URL
const Download = () => {
	const [showDownloadModal, setShowDownloadModal] = useState(false)
	const [errorMessage, setErrorMessage] = useState("")
	const [fileSignature, setFileSignature] = useState("")

	const onFinish = (values) => {
		setErrorMessage("")
		setFileSignature("")
		values.order_number = values.order_number.trim()
		values.access_code = values.access_code.trim()
		API.findOrder(values).then((res) => {
			if (!res.data) setErrorMessage("Order Not Found.")
			else {
				if (typeof res.data !== "object") {
					setErrorMessage(res.data)
				} else {
					if (moment().isSameOrAfter(moment(res.data.download_expiration).add(1, "day"), "day"))
						setErrorMessage("This product serial number has expired.")
					else if (res.data.downloads_available < 1)
						setErrorMessage("There are no available downloads for this product serial number.")
					else {
						API.findProduct(encodeURIComponent(res.data.product)).then((res) => {
							if (res.data && typeof res.data === "object" && res.data.filename !== undefined
								&& res.data.file_hash !== undefined && res.data.file_hash !== 'UNSET') {
								setFileSignature([
									"Please verify the integrity of the downloaded file.",
									"File: " + res.data.filename, 
									"SHA-256: " + res.data.file_hash
								]);
							}
							window.open(`${baseURL}${values.order_number}/${values.access_code}`)
							setShowDownloadModal(true)
						})
					}
				}
			}
		})
	}

	return (
		<div style={{ width: 900, margin: "10px auto 0", justifyContent: "center" }}>
			<div
				style={{
					backgroundImage: `url(${ICDD_download_header})`,
					backgroundPositionY: 10,
					backgroundPosition: "center",
					backgroundSize: "contain",
					backgroundRepeat: "no-repeat",
					width: "100%",
					height: 200,
				}}
			></div>
			<div
				style={{
					backgroundImage: `url(${thank_you})`,
					backgroundPositionY: 0,
					backgroundPosition: "center",
					backgroundSize: "50%",
					backgroundRepeat: "no-repeat",
					width: "100%",
					height: 110,
					marginTop: 20,
				}}
			></div>
			<div
				style={{
					backgroundPosition: "center",
					backgroundSize: "72%",
					backgroundRepeat: "no-repeat",
					width: "100%",
					height: 150,
					marginTop: 10,
				}}
			>
				<Row justify="center">
					<Col span="4">
						<a href="https://www.icdd.com/pdf-5/" target="_blank">
							<img src={img_pdf_5} height="150" />
						</a>
					</Col>
					<Col span="4" style={{ textAlign: "center" }}>
						<a href="https://www.icdd.com/pdf-4-axiom" target="_blank">
							<img src={img_pdf_4_axiom} height="150" />
						</a>
					</Col>
					<Col span="4" style={{ textAlign: "center" }}>
						<a href="https://www.icdd.com/pdf-4-minerals" target="_blank">
							<img src={img_pdf_4_minerals} height="150" />
						</a>
					</Col>
					<Col span="4" style={{ textAlign: "center" }}>
						<a href="https://www.icdd.com/pdf-2" target="_blank">
							<img src={img_pdf_2} height="150" />
						</a>
					</Col>
				</Row>
			</div>

			<p style={{ textAlign: "center", fontSize: 16, marginTop: 20 }}>
				To begin your download, enter your ICDD order number and product serial number below. Your ICDD order number and
				product serial number(s) were provided to you in your order confirmation email that contained the link to this
				page. If you require assistance, please contact <a href="mailto:sales@icdd.com">sales@icdd.com</a> or call
				1-610-325-9814.
			</p>
			<div style={{ width: 800, margin: "60px auto 60px" }}>
				{errorMessage.length > 0 && (
					<Alert style={{ marginBottom: 20, textAlign: "center" }} message={errorMessage} type="error" closable={false} />
				)}
				{fileSignature.length > 0 && (
					<Card size="small" style={{ marginBottom: 20, backgroundColor: "#e6f4ff", border: "1px solid #91caff" }}>
						{fileSignature.map(item => (<p key={item}>{item}</p>))}
					</Card>
				)}
				{/* <Card title="ICDD Customer Download" style={{ margin: 20 }}> */}
				<Form name="basic" labelCol={{ span: 10 }} wrapperCol={{ span: 16 }} onFinish={onFinish} autoComplete="off">
					<Form.Item
						label="Order Number"
						name="order_number"
						rules={[{ required: true, message: "Order number is required" }]}
					>
						<Input placeholder=" " />
					</Form.Item>
					<Form.Item
						label="Product Serial Number"
						name="access_code"
						rules={[{ required: true, message: "Product serial number is required" }]}
					>
						<Input />
					</Form.Item>

					<Form.Item wrapperCol={{ offset: 10, span: 16 }}>
						<Button type="primary" htmlType="submit">
							Download
						</Button>
					</Form.Item>
				</Form>
				{/* </Card> */}
			</div>

			<div>
				<Row>
					<Col span="8">
						<p>
							<strong>Contact ICDD</strong>
						</p>
						12 Campus Blvd<br></br> Newtown Square, PA 19073, USA<br></br>
						Phone: (610) 325-9814<br></br>
						Fax: (610) 325-9823<br></br>
						Email: <a href="mailto:info@icdd.com">info@icdd.com</a>
					</Col>
					<Col span="8">
						<p style={{ textAlign: "center" }}>
							Visit us at{" "}
							<a href="https://www.icdd.com" target="_blank">
								www.icdd.com
							</a>
							<br></br>
							<strong>Helpful Links:</strong>
							<br></br>
							<a href="https://www.icdd.com/brochures-and-flyers/" target="_blank">
								ICDD Product Brochures and Flyers
							</a>
							<br></br>
							<a href="https://www.icdd.com/licensing-process/" target="_blank">
								Licensing Information
							</a>
							<br></br>
							<a href="https://www.icdd.com/product-tutorials/" target="_blank">
								Product Tutorials
							</a>
						</p>
					</Col>
					<Col span="8">
						<div className="social-wrapper">
							<ul>
								<li>
									<a href="https://twitter.com/icddicdd" target="_blank">
										<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="34" height="34" viewBox="0 0 20 20">
											<path
												id="social-twitter"
												d="M20.576,19.721l-6.852-9.488l4.552-5.602c0.349-0.429,0.283-1.059-0.146-1.407c-0.427-0.347-1.058-0.283-1.406,0.146	l-4.213,5.185L9.057,3.771C8.707,3.287,8.146,3,7.549,3H4.078C3.42,3,3.039,3.746,3.424,4.279l5.911,8.184l-5.611,6.906	c-0.348,0.429-0.283,1.059,0.146,1.407C4.055,20.927,4.278,21,4.5,21c0.291,0,0.579-0.126,0.777-0.369l5.271-6.488l4.396,6.086	c0.35,0.484,0.91,0.771,1.507,0.771h3.471C20.58,21,20.961,20.254,20.576,19.721z"
											/>
										</svg>
									</a>
								</li>
								<li>
									<a href="https://www.instagram.com/theICDD/" target="_blank">
										<svg xmlns="http://www.w3.org/2000/svg" width="31.518" height="31.51" viewBox="0 0 31.518 31.51">
											<path
												id="social-instagram"
												d="M15.757-21.586a8.066,8.066,0,0,0-8.079,8.079,8.066,8.066,0,0,0,8.079,8.079,8.066,8.066,0,0,0,8.079-8.079A8.066,8.066,0,0,0,15.757-21.586Zm0,13.331A5.262,5.262,0,0,1,10.5-13.507a5.257,5.257,0,0,1,5.252-5.252,5.257,5.257,0,0,1,5.252,5.252,5.262,5.262,0,0,1-5.252,5.252ZM26.051-21.916A1.884,1.884,0,0,0,24.166-23.8a1.884,1.884,0,0,0-1.884,1.884,1.88,1.88,0,0,0,1.884,1.884A1.88,1.88,0,0,0,26.051-21.916ZM31.4-20a9.325,9.325,0,0,0-2.545-6.6,9.387,9.387,0,0,0-6.6-2.545c-2.6-.148-10.4-.148-13,0a9.373,9.373,0,0,0-6.6,2.538,9.356,9.356,0,0,0-2.545,6.6c-.148,2.6-.148,10.4,0,13a9.325,9.325,0,0,0,2.545,6.6,9.4,9.4,0,0,0,6.6,2.545c2.6.148,10.4.148,13,0a9.325,9.325,0,0,0,6.6-2.545A9.387,9.387,0,0,0,31.4-7.01c.148-2.6.148-10.392,0-12.994ZM28.041-4.219a5.318,5.318,0,0,1-3,3c-2.074.823-7,.633-9.288.633s-7.221.183-9.288-.633a5.318,5.318,0,0,1-3-3c-.823-2.074-.633-7-.633-9.288s-.183-7.221.633-9.288a5.318,5.318,0,0,1,3-3c2.074-.823,7-.633,9.288-.633s7.221-.183,9.288.633a5.318,5.318,0,0,1,3,3c.823,2.074.633,7,.633,9.288S28.863-6.286,28.041-4.219Z"
												transform="translate(0.005 29.262)"
											/>
										</svg>
									</a>
								</li>
								<li>
									<a href="https://www.linkedin.com/company/2345261/admin/" target="_blank">
										<svg xmlns="http://www.w3.org/2000/svg" width="29.75" height="29.755" viewBox="0 0 29.75 29.755">
											<path
												id="social-linkedin"
												d="M6.659,0H.491V-19.862H6.659ZM3.572-22.571A3.6,3.6,0,0,1,0-26.177a3.572,3.572,0,0,1,5.358-3.093,3.572,3.572,0,0,1,1.786,3.093A3.6,3.6,0,0,1,3.572-22.571ZM29.743,0H23.589V-9.669c0-2.3-.046-5.259-3.207-5.259-3.207,0-3.7,2.5-3.7,5.093V0H10.523V-19.862h5.915v2.709h.086A6.481,6.481,0,0,1,22.36-20.36c6.242,0,7.39,4.111,7.39,9.45V0Z"
												transform="translate(0 29.755)"
											/>
										</svg>
									</a>
								</li>
								<li>
									<a href="https://www.facebook.com/TheICDD" target="_blank">
										<svg xmlns="http://www.w3.org/2000/svg" width="19.281" height="36" viewBox="0 0 19.281 36">
											<path
												id="social-facebook"
												d="M19.627-11.25l1-6.515H14.375v-4.228c0-1.782.873-3.52,3.673-3.52h2.842V-31.06a34.658,34.658,0,0,0-5.045-.44c-5.148,0-8.513,3.12-8.513,8.769v4.965H1.609v6.515H7.332V4.5h7.043V-11.25Z"
												transform="translate(-1.609 31.5)"
											/>
										</svg>
									</a>
								</li>
								<li>
									<a href="https://www.youtube.com/user/TheICDD" target="_blank">
										<svg xmlns="http://www.w3.org/2000/svg" width="38.4" height="27" viewBox="0 0 38.4 27">
											<path
												id="social-youtube"
												d="M38.648-22.775a4.825,4.825,0,0,0-3.395-3.417C32.258-27,20.25-27,20.25-27s-12.008,0-15,.808a4.825,4.825,0,0,0-3.395,3.417c-.8,3.014-.8,9.3-.8,9.3s0,6.289.8,9.3A4.753,4.753,0,0,0,5.247-.808C8.242,0,20.25,0,20.25,0s12.008,0,15-.808A4.753,4.753,0,0,0,38.648-4.17c.8-3.014.8-9.3.8-9.3S39.45-19.761,38.648-22.775ZM16.323-7.763V-19.182l10.036,5.71L16.323-7.763Z"
												transform="translate(-1.05 27)"
											/>
										</svg>
									</a>
								</li>
							</ul>
						</div>
					</Col>
				</Row>
			</div>
			<div style={{ fontSize: 12, marginTop: 20 }}>
				ICDD, the ICDD logo, PDF, Materials Data, JADE, Materials Data-JADE logo, Denver X-ray Conference, and Denver
				X-ray Conference logo are registered in the U.S. Patent and Trademark Office. Powder Diffraction File is a
				trademark of the JCPDS-International Centre for Diffraction Data. ©1997-{(new Date().getFullYear())} JCPDS 
				International Centre for Diffraction Data.
			</div>

			<Modal
				open={showDownloadModal}
				title="Downloading"
				closable={false}
				footer={null}
				maskClosable={false}
				destroyOnClose={true}
				onCancel={() => setShowDownloadModal(false)}
				width={800}
			>
				<p>File download started...</p>

				{fileSignature.length > 0 && (
					<Card size="small" style={{ marginBottom: 20, backgroundColor: "#e6f4ff", border: "1px solid #91caff" }}>
						{fileSignature.map(item => (<p key={item}>{item}</p>))}
					</Card>
				)}

				<p>
					If there is a problem with the download starting, please verify a popup blocker is not preventing the
					download.
				</p>
				<Button type="primary" onClick={() => setShowDownloadModal(false)}>
					OK
				</Button>
			</Modal>
		</div>
	)
}

export default Download
